import css from "./SoftwareEngineering.module.css";

const Workplace = ({ children, logo, info }) => {
  const { dates, employer, location, role } = info;
  return (
    <div className="column">
      <div className={css.info}>
        <div className={css.info_top}>
          <img className={css.logo} src={logo.src} alt={logo.alt} />
          <div className="column">
            <div className="flex between">
              <strong>{role}</strong>
              <i className="rtext">{location}</i>
            </div>
            <div className="flex between">
              <span>{employer}</span>
              <i className="rtext">{dates}</i>
            </div>
            <div className={css.info_primary}></div>
          </div>
        </div>
        {children && (
          <div className="column g05" style={{ paddingLeft: "0.5rem" }}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default Workplace;
